
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 85.333 512 341.333"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","d":"M0 85.339h512v341.326H0z"}}),_c('path',{attrs:{"d":"M0 85.339h512v113.775H0z"}}),_c('path',{attrs:{"fill":"#6DA544","d":"M0 312.89h512v113.775H0z"}}),_c('path',{attrs:{"fill":"#D80027","d":"M256 256.006L0 426.669V85.331z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M77.913 224.802l7.876 16.469 17.786-4.11-7.965 16.426 14.303 11.343-17.808 4.014.049 18.255-14.241-11.421-14.241 11.421.05-18.255-17.809-4.014 14.303-11.343-7.965-16.426 17.786 4.11z"}})])
          )
        }
      }
    